import { render, staticRenderFns } from "./MultipleMailComposer.vue?vue&type=template&id=6f074f79"
import script from "./MultipleMailComposer.vue?vue&type=script&lang=js"
export * from "./MultipleMailComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports